import Checkbox from '@oncolens/oncolens-ui/lib/components/FormControls/Checkbox';
import React from 'react';
import FormField from '@oncolens/oncolens-ui/lib/libraries/FormField';
import store from './store';

const ConsentCheckbox = () => (
  <div className="my-6">
    <FormField name="hasGivenConsent" store={store}>
      {({ value, onChange }) => (
        <Checkbox
          id="consent"
          htmlName="consent"
          label="I certify the information included (i) does not contain any PHI, or otherwise identify or allow for the identification of any individual for purposes of HIPAA, and (ii) is accurate and applicable for the purposes of my requested review."
          required
          onClick={onChange}
          inputProps={{
            checked: value
          }}
          alignment="right"
        />
      )}
    </FormField>
  </div>
);

export default ConsentCheckbox;